exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "input:disabled{background:#f1f1f1}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/components/TextField.vue"],"names":[],"mappings":"AACA,eACE,kBAAoB,CACrB","file":"TextField.vue","sourcesContent":["\ninput:disabled {\n  background: #f1f1f1;\n}\n\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3e1491b2","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/TextField.vue
// module id = 1627
// module chunks = 3 9 10 16 25